var ModalStore = /** @class */ (function () {
    function ModalStore() {
        var _this = this;
        this.isOpen = false;
        this.open = function () {
            return _this.isOpen = true;
        };
        this.close = function () {
            return _this.isOpen = false;
        };
        this.toggle = function () {
            return _this.isOpen = !_this.isOpen;
        };
    }
    return ModalStore;
}());
export { ModalStore };
